import { ComponentPropsWithoutRef } from 'react';

const StarIcon = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg width={13} height={13} viewBox="0 0 11.898 11.823" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="m4.1104 3.8918-4.1104 0.62403 2.974 3.0301-0.70118 4.2771 3.6752-2.0197 3.6783 2.0197-0.70221-4.2771 2.974-3.0301-4.1094-0.62403-1.8407-3.8918z"
    />
  </svg>
);

export default StarIcon;
